export default {
  myLocation: {
    stopShowingCurrentLocation: 'Kliknutím zastavíte zobrazování aktuální polohy',
    showCurrentLocation: 'Kliknutím zobrazíte svou aktuální polohu',
    yourCurrentLocation: 'Vaše aktuální poloha',
    continuously: 'Nepřetržitě',
    onlyOnce: 'Pouze jednou',
    continuouslyLocation: 'Obnovení pozice každé 2 sekundy',
    onlyOnceLocation: 'Získat pozici pouze jednou',
    myPositionToolTip: 'Aktivace polohy pro zobrazení vaší polohy a snadnější vyhledávání míst v okolí'
  }
}
